import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core'
import useStyle from './style';

import logoLoja from '../../Assets/img/logo-loja.png'

import React from 'react'

const ModelPrint = React.forwardRef((props, ref) => {
  return (
    <div className={`${useStyle().containerPrint}`} ref={ref}>
        <Box className={`${useStyle().logo}`}>
            <img src={logoLoja} alt="loja santo antonio" />
        </Box>
        <Box className={`${useStyle().infoHeader}`}>
            <Typography>Estamos separando o seu pedido!</Typography>
            <Typography>1°- Faça o pagamento no caixa</Typography>
            <Typography>2°- Retire as cascas na casa ao lado (n° 712)</Typography>
            <Typography>Obrigado!</Typography>
        </Box>
        <Box className={`${useStyle().containerOrders}`}>
            <Box className={`${useStyle().boxOrder}`}>
                <Typography className={`${useStyle().numberOrder}`}>N° PEDIDO: </Typography>
                <Typography className={`${useStyle().numberOrder}`}>{props.numberOrder}</Typography>
            </Box>
        </Box>

        <Box className={`${useStyle().containerItems}`}>
              <Table>
              <TableHead>
                  <TableRow>
                      <TableCell align="center">Nome do produto</TableCell>
                      <TableCell align="center">Quantidade</TableCell>
                  </TableRow>
              </TableHead>
              <TableBody>
              {props?.items !== undefined ?
                JSON.parse(props?.items.items).map((item, index) => (
                      <TableRow key={index}>
                          <TableCell align="center">{item.name}</TableCell>
                          <TableCell align="center"><span>{item.qtd}</span></TableCell>
                      </TableRow>
                  )): (
                      <TableRow>
                          <TableCell align="center">Nenhum produto encontrado</TableCell>
                          <TableCell align="center">-</TableCell>
                      </TableRow>
                  )}
              </TableBody>
          </Table>

        </Box>
        <Box className={`${useStyle().infoFooter}`}>
            <Typography>Acesse nosso site e aproveite as ofertas!</Typography>
            <Typography>www.lojasantoantonio.com.br</Typography>
        </Box>
    </div>
)})

export default ModelPrint
